export default "__VITE_ASSET__Do1c37zS__"